import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipmentsSearchLabel: {
    defaultMessage: 'Shipments Quicksearch',
    description: 'title for the form used to submit quicksearch on the shipments page',
    id: 'NX23Xj',
  },
  shipmentsSearchPlaceholder: {
    defaultMessage: 'Search Shipments...',
    description: 'shipmentsPage.search.labels.search-value',
    id: 'E4pRvr',
  },
  returnsSearchLabel: {
    defaultMessage: 'Returns Quicksearch',
    description: 'Label for returns search input',
    id: 'YplZwo',
  },
  returnsSearchPlaceholder: {
    defaultMessage: 'Search Returns...',
    description: 'placeholder text for returns search input',
    id: 'jSeU6P',
  },
});
